import { render } from "./DialogCambioGomme.vue?vue&type=template&id=ebfde690"
import script from "./DialogCambioGomme.vue?vue&type=script&lang=js"
export * from "./DialogCambioGomme.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__